module.exports = __webpack_public_path__ + "img/Stage_7_Diff.8e060056.jpg";